var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 140 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40.1199 20.5801H36.1499V39.0001H40.1199V20.5801Z",
  fill: "#EAEAEA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M89.24 20.5801H85.27V39.0001H89.24V20.5801Z",
  fill: "#EAEAEA"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.87 29.3701L52.13 20.5801H46.85L39.98 29.3201V29.4101L47.31 39.0001H52.58L44.87 29.3701Z",
  fill: "#EAEAEA"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M107.42 20.5801L102.71 35.0001L97.99 20.5801H92.29V39.0001H95.81V24.0501L100.71 39.0001H104.71L109.61 24.0501V39.0001H113.12V20.5801H107.42Z",
  fill: "#EAEAEA"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M74.3599 35.88H70.1699V39H76.8099C77.6236 39 78.4294 38.8396 79.181 38.5279C79.9327 38.2162 80.6155 37.7593 81.1905 37.1835C81.7654 36.6076 82.2211 35.9241 82.5316 35.1719C82.8421 34.4197 83.0012 33.6137 82.9999 32.8V20.52H78.9999V31.14C78.9999 34.06 78.7699 35.88 74.3599 35.88Z",
  fill: "#EAEAEA"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M64.0901 20.52H59.8201L52.1201 39H56.4501L58.1301 34.67H65.7801L67.4701 39H71.8001L64.0901 20.52ZM59.3901 31.43L61.9301 24.89L64.5201 31.43H59.3901Z",
  fill: "#EAEAEA"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M125.1 20.52H120.83L113.12 39H117.45L119.14 34.67H126.79L128.47 39H132.8L125.1 20.52ZM120.4 31.43L122.94 24.89L125.53 31.43H120.4Z",
  fill: "#EAEAEA"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.84 9H0V15.79H6.84V9Z",
  fill: "#E6002D"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.84 20.5801H0V39.0001H6.84V20.5801Z",
  fill: "#E6002D"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5202 20.5801H11.6802V39.0001H18.5202V20.5801Z",
  fill: "#E6002D"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6299 9V15.79H20.7399C21.0574 15.7532 21.3792 15.7897 21.6804 15.8967C21.9816 16.0037 22.2542 16.1784 22.4773 16.4073C22.7004 16.6362 22.8681 16.9132 22.9673 17.2171C23.0666 17.5209 23.0948 17.8435 23.0499 18.16V39H29.7899V14C29.7899 14 29.8899 9 23.9999 9H11.6299Z",
  fill: "#E6002D"
})));
export default SvgLogo;